module.exports = __webpack_public_path__ + "static/media/mum-kids04.08309225.png";